<template>
  
  <div class="paragraph3 grid grid__item_span-12 p0 m0">
   
    <div class="grid__item_span-10 grid m0 p0" v-bind:style="{ color: item.paragraph_v3_text_colour }" v-html="item.project_v3_paragraph">
    </div>
 
  </div>

</template> 

<script>

import animateScroll from '../../assets/js/projectAnimation.js'
var inViewport = require('vue-in-viewport-mixin')

export default {
  name: 'Paragraph3',
  props: [
    'item'
  ],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    animateElements () {
      animateScroll.animate()
    }
  },
  mixins: [
    inViewport
  ],
  watch: {
    'inViewport.now': function (visible) {
      // console.log('This component is ' + (visible ? 'in-viewport' : 'hidden'))
      if (visible === true) {
        // console.log('YES')
        this.animateElements()
      } else {
        // console.log('no luck')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/project/paragraph3.vue